import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'react-feather'
import logo_white from '../../assets/images/logo-white.png'

export default function Thankyou() {
  return (
    <>
      {/* Секция на весь экран с overflow для видео-фона */}
      <section className="relative h-screen overflow-hidden flex items-center justify-center px-4">
        
        {/* Видео на заднем плане.
            Вместо фиксированного соотношения, растягиваем на всю секцию */}
        <iframe title="iframe" src="https://player.vimeo.com/video/502163294?background=1&autoplay=1&loop=1&byline=0&title=0" className="absolute top-1/2 start-1/2 ltr:-translate-x-1/2 rtl:translate-x-1/2 -translate-y-1/2 w-screen h-[56.25vw] min-h-screen min-w-[177.77vw]"></iframe>

        {/* «Карточка» с текстом поверх видео (делаем шире) */}
        <div className="relative z-10 w-full max-w-2xl 
                        bg-[#0F172A] text-white rounded-xl shadow-lg 
                        px-10 py-10 mx-auto">
          {/* Логотип и бренд */}
          <div className="flex items-center justify-center">
            <img src={logo_white} alt="logo" className="h-12 mr-2" />
          </div>

          {/* Заголовок */}
          <h1 className="text-3xl md:text-4xl font-bold mt-6 mb-4 text-center">
            Thanks for Your Purchase! <span role="img" aria-label="party">🎉</span>
          </h1>
          
          <p className="text-base leading-relaxed mb-1 text-center">
            If your NFT isn’t visible after a successful
          </p>
          <p className="text-base leading-relaxed mb-4 text-center">
            transaction – check your hidden items on the wallet.
          </p>
          <p className="text-base leading-relaxed mb-1 text-center">
            Still need help?
          </p>
          
          <p className="text-base leading-relaxed mb-8 text-center">
            <Link to="/contact" className="underline text-violet-300">
              Reach out to us
            </Link>
            — we’ve got you covered! <span role="img" aria-label="rocket">🚀</span>
          </p>
          
          {/* Кнопка «Back to Homepage» */}
          <div className="text-center">
            <Link
              to="/"
              className="inline-block bg-violet-600 hover:bg-violet-700 
                         transition-colors text-white rounded-full 
                         px-8 py-3 text-lg font-semibold" // Увеличиваем размер текста (с text-sm до text-lg)
            >
              Back to Homepage
            </Link>
          </div>

        </div>
      </section>

      {/* Кнопка «Назад» в правом нижнем углу, если нужна */}
      <div className="fixed bottom-3 right-3 z-20">
        <Link
          to="/"
          className="back-button btn btn-icon bg-violet-600 hover:bg-violet-700 
                     text-white rounded-full p-3 transition-colors"
        >
          <ArrowLeft className="h-5 w-5" />
        </Link>
      </div>
    </>
  )
}
